import React, { useRef } from 'react';
import Card from './Card';
import EntryHeader from './EntryHeader';
import Media from './Media';
import MediaLeft from './MediaLeft';
import MediaActions from './MediaActions';
import MediaBody from './MediaBody';
import styles from './feed-media-showcase.scss';
import EntryBlock from './EntryBlock';
import EntryBody from './EntryBody';
import EntryFooter from './EntryFooter';
import EntryMedia from './EntryMedia/EntryMedia';

const FeedMediaShowCase = () => {
  const ref = useRef();

  const cursorData = {
    updated_at: 2,
    rank: 1
  };

  return (
    <div className={styles.container}>
      <div className={styles.entry}>
        <Card index={0} cursorData={cursorData} ref={ref}>
          <span>EntryHeader | Media (default)</span>
          <EntryHeader className={styles.entryHeader}>
            <Media className={styles.media}>Media</Media>
            <Media className={styles.media}>
              <MediaLeft className={styles.mediaLeft}>MediaLeft</MediaLeft>
              <MediaBody className={styles.mediaBody}>MediaBody</MediaBody>
              <MediaActions className={styles.mediaActions}>
                MediaActions
              </MediaActions>
            </Media>
          </EntryHeader>
          <span>EntryBlock</span>
          <EntryBlock className={styles.entryBlock}>
            <ul>
              <li>
                <EntryHeader className={styles.entryHeader}>
                  EntryHeader
                </EntryHeader>
              </li>
              <li>
                <EntryHeader className={styles.entryHeader}>
                  EntryHeader
                </EntryHeader>
              </li>
            </ul>
          </EntryBlock>
          <span>EntryBody (default)</span>
          <EntryBody className={styles.entryBody}>
            <Media className={styles.media} centered={true}>
              <MediaBody className={styles.mediaBody}>MediaBody</MediaBody>
            </Media>
          </EntryBody>
          <span>EntryBody inset</span>
          <EntryBody inset={true} className={styles.entryBody}>
            <Media className={styles.media} centered={true}>
              <MediaBody className={styles.mediaBody}>MediaBody</MediaBody>
            </Media>
          </EntryBody>
        </Card>
      </div>

      <div className={styles.entry}>
        <Card index={0} cursorData={cursorData} ref={ref}>
          <span>EntryHeader | Media - centered</span>
          <EntryHeader className={styles.entryHeader}>
            <Media className={styles.media} centered={true}>
              <MediaLeft className={styles.mediaLeft}>MediaLeft</MediaLeft>
              <MediaBody className={styles.mediaBody}>MediaBody</MediaBody>
              <MediaActions className={styles.mediaActions}>
                MediaActions
              </MediaActions>
            </Media>
          </EntryHeader>
        </Card>
      </div>

      <div className={styles.entry}>
        <Card index={0} cursorData={cursorData} ref={ref}>
          <span>EntryHeader | Media | MediaBody only</span>
          <EntryHeader className={styles.entryHeader}>
            <Media className={styles.media} centered={true}>
              <MediaBody className={styles.mediaBody}>MediaBody</MediaBody>
            </Media>
          </EntryHeader>
        </Card>
      </div>

      <div className={styles.entry}>
        <Card index={0} cursorData={cursorData} ref={ref}>
          <span>EntryFooter | default</span>
          <EntryFooter className={styles.entryFooter}>
            <Media className={styles.media}>Media</Media>
          </EntryFooter>
          <span>EntryFooter | inset (true)</span>
          <EntryFooter className={styles.entryFooter} inset={true}>
            <Media className={styles.media}>Media</Media>
          </EntryFooter>
        </Card>
      </div>

      <div className={styles.entry}>
        <Card index={0} cursorData={cursorData} ref={ref}>
          <span>EntryMedia | default</span>
          <EntryMedia className={styles.entryMedia}>
            <Media className={styles.media}>Media</Media>
          </EntryMedia>
          <span>EntryMedia | inset (true)</span>
          <EntryMedia className={styles.entryMedia} inset={true}>
            <Media className={styles.media}>Media</Media>
          </EntryMedia>
        </Card>
      </div>
    </div>
  );
};

export default FeedMediaShowCase;
